import { CalendarCheckOutlineIcon } from './CalendarCheckOutlineIcon';

/**
 * author: Google
 * id 62AD0407-3DB5-48B0-8A26-3C5A07C78582
 * name calendar-check-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-check-outline.svg
 * tags
 * - Date / Time 
 */
export const CalendarTaskOutlineIcon = CalendarCheckOutlineIcon;
export default CalendarTaskOutlineIcon